module.exports = __webpack_public_path__ + "static/media/Blaka-Regular.1862599d.ttf";